/**
 * Verifica si el evento ya ha iniciado (hora actual >= event_date + event_start_time)
 */
export function hasEventStarted(event: { event_date: string; event_start_time?: string | null }): boolean {
    if (!event.event_date || !event.event_start_time) return false;

    const eventDate = new Date(event.event_date);
    const [hours, minutes] = event.event_start_time.split(':');
    eventDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);

    return new Date() >= eventDate;
}

/**
 * Verifica si el evento ya ha terminado (hora actual > event_date + event_end_time)
 */
export function hasEventEnded(event: { event_date: string; event_end_time?: string | null }): boolean {
    if (!event.event_date || !event.event_end_time) return false;

    const eventDate = new Date(event.event_date);
    const [hours, minutes] = event.event_end_time.split(':');
    eventDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);

    return new Date() > eventDate;
}

/**
 * Se puede reanudar si: evento está finalizado Y NO ha iniciado aún
 * NOTA: Esta función está deshabilitada. Ahora todos los eventos finalizados se republican directamente.
 */
export function canResumeEvent(_event: { status: string; event_date: string; event_start_time?: string | null }): boolean {
    // Deshabilitado: Ahora solo se permite republicar, no reanudar
    return false;
}

/**
 * Se puede volver a publicar si: evento está finalizado
 * Los eventos finalizados pueden republicarse N veces, sin importar las fechas
 */
export function canRepublishEvent(event: { status: string; event_date?: string; event_end_time?: string | null }): boolean {
    return event.status === 'finished';
}

export function getEventStatusLabel(status: string): 'Finalizado' | 'Publicado' | 'Borrador' | 'Archivado' {
    if (status === 'finished') return 'Finalizado';
    if (status === 'published') return 'Publicado';
    if (status === 'archived') return 'Archivado';
    return 'Borrador';
}

export function getEventDisplayStatus(event: {
    status: string;
    event_date: string;
    event_end_time?: string | null;
}): string {
    if (event.status === 'published' && hasEventEnded(event)) return 'finished';
    return event.status;
}
